// export const baseURL = "https://api.laminance.com"

export const baseURL = "http://localhost:5000"

const SummaryAPI = {
    register :{
        url :"/api/user/register",
        method:"post"
    },
    login :{
        url :"/api/user/login",
        method:"post"
    },
    forgot_password :{
        url :"/api/user/forgot-password",
        method:"put"
    },
    otp_verification:{
        url :"/api/user/verify-forgot-password-otp",
        method:"put"
    },
    reset_password: {
        url: "/api/user/reset-password",
        method: "put",
    },
    refreshtoken: {
        url: "/api/user/refresh-token",
        method: "post",
    },
    userDetail: {
        url: "/api/user/user-Detail",
        method: "get",
    },
    logout: {
        url: "/api/user/logout",
        method: "get",
    },
    uploadAvatar :{
        url : "/api/user/update-avatar",
        method:"put"
    },
    updateuserdetails :{
        url : "/api/user/update-user",
        method:"put"
    },
    addCategory :{
        url : "/api/category/add-category",
        method:"post"
    },
    uploadImage :{
        url : "/api/file/upload",
        method:"post"
    },
    getAllCategories :{
        url : "/api/category/get",
        method:"get"
    },
    updateCategory :{
        url : "/api/category/update-category",
        method:"put"
    },
    deleteCategory :{
        url : "/api/category/delete-category",
        method:"delete"
    },
    
    // Admin User Management Endpoints
    getAllUsers: {
        url: "/api/user/admin/users",
        method: "get"
    },
    updateUserStatus: {
        url: "/api/user/admin/users/:userId/status",
        method: "put"
    },
    updateUserRole: {
        url: "/api/user/admin/users/:userId/role",
        method: "put"
    },
    deleteUser: {
        url: "/api/user/admin/users/:userId",
        method: "delete"
    },
    adminResetPassword: {
        url: "/api/user/admin/users/:userId/reset-password",
        method: "post"
    }
}

export default SummaryAPI